var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close({ contacted: _vm.contacted })
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          {
            class: [
              "scrollbar-check",
              "bg-lightest-blue",
              { "flex-grow-1": _vm.contacted }
            ]
          },
          [
            _c("JonInfo", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "message",
                    fn: function() {
                      return [
                        _c("div", [
                          _c("b", [
                            _vm._v("Möchtest du den Arbeitgeber kontaktieren?")
                          ]),
                          _c("br"),
                          _vm._v('\n\t\t\t\t\tDas passiert, wenn du "'),
                          _c("b", [_vm._v("Anonym kontaktieren")]),
                          _vm._v('" bestätigst:\n\t\t\t\t')
                        ]),
                        _vm._v(" "),
                        _c("ol", { staticClass: "pl-3 mt-3" }, [
                          _c("li", [
                            _vm._v(
                              "\n\t\t\t\t\t\tWir senden deine anonyme Kontaktanfrage an den Arbeitgeber.\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              '\n\t\t\t\t\t\tDer Arbeitgeber sieht dein anonymes Profil und das "Matching"/die Übereinstimmung, er\n\t\t\t\t\t\tsieht aber weder deinen Namen, noch deine Kontaktdaten, dein Alter oder deinen Wohnort und\n\t\t\t\t\t\tauch noch nicht deinen Lebenslauf oder den Namen bisheriger Arbeitgeber (wenn du das schon\n\t\t\t\t\t\teingetragen hast).\n\t\t\t\t\t'
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n\t\t\t\t\t\tNimmt der Arbeitgeber die anonyme Kontaktanfrage an, dann erfährst du den Namen des\n\t\t\t\t\t\tArbeitgebers, deine Ansprechperson für den Job und die nächsten Schritte.\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n\t\t\t\t\t\tDann kannst du entscheiden, ob du an weiteren Schritten mit dem Arbeitgeber interessiert\n\t\t\t\t\t\tbist und deinen Namen offenlegst.\n\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Viel Erfolg!")])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4137444933
              )
            }),
            _vm._v(" "),
            _vm.contacted
              ? _c("div", { staticClass: "message-list mt-4" }, [
                  _c(
                    "div",
                    { staticClass: "message-list--items" },
                    [
                      _c("ListItem", {
                        attrs: {
                          "custom-text":
                            "<b>Kontaktanfrage erfolgreich gesendet</b><br/>Sobald die Firma antwortet, erhältst du weitere Infos.",
                          "custom-time-stamp": new Date(),
                          "is-recipient": false,
                          "force-right": "",
                          icon: "checkmark"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        !_vm.contacted
          ? _c("footer", [
              _c(
                "div",
                { staticClass: "flex-grow-1 text-right" },
                [
                  _c("Button", {
                    attrs: {
                      text: "Anonym kontaktieren",
                      icon: "checkmark",
                      disabled: _vm.contacting,
                      loading: _vm.contacting
                    },
                    on: { click: _vm.contact }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Firma kontaktieren")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }